import inicialState from './histo.state';
import * as actions from './histo.action';

const histologiaReducer = (state = inicialState, action) => {
  switch (action.type) {
    case actions.HISTOLOGIA_FINALIZADA:
      return {
        ...state,
        histologiaFinalizada: action.payload.histologiaFinalizada,
      };
    default:
      return state;
  }
};

export default histologiaReducer;



// WEBPACK FOOTER //
// ./src/pages/laudo/etapas/histo/histo.reducer.js